import {h} from 'preact';
import 'jquery-file-download';
import constants, { MyMenusPath } from '../../constants';
import Renderer from "../../canvas/renderer";
import util, {usePreview} from "../../util";
import store from "../../store";
import * as actions from "../../actions";
import designService from "../../service/designService";
import History from "../History";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const {dispatch} = store;
const {goToView, setVersionPreview} = actions;

export default function MobileAppHeader({toggleMenu, isVersionPreview, props, pageInViewportNumber}) {

  function discard() {
    Renderer.revertRevisionPreview();
    dispatch(goToView('text'));
    dispatch(setVersionPreview(false));
    util.nextTick(window.location.reload);
  }

  function goToHomePage() {
    $('.modal-back').show();

    props.setIsSaved(false);
    props.setIsSaving(true);

    if (props.hasChanges) {
      designService.updateDesign({
        id: props.designId,
        html: Renderer.getPagesContent(),
        name: props.designName,
        lastSavedTag: props.lastSavedTag,
        hasVideo: props.hasVideo
      }).then(async () => {
        props.setIsSaved(true);
        props.setIsSaving(false);
        props.setShowExitWarning(false);

        // if came from longtail, go back to default location
        if (document.referrer.includes('template')) {
          window.location = `${MyMenusPath}/designs/${props.locationId}`;
        } else {
          window.location = '/';
        }
      }).catch((err) => {
        $('.modal-back').hide();
        props.setIsSaving(false);

        if (props.isTemplate) {
          designService.getDesignAlternativeName(props.designId, props.designName)
            .then((resp) => {
              props.setDesignName(resp.data);
              this.setState({oldNameSet: false});
            })
        }
      });
    } else {
      // if came from longtail, go back to default location
      if (document.referrer.includes('template')) {
        window.location = `${MyMenusPath}/designs/${props.locationId}`;
      } else {
        window.location = '/';
      }
    }
  }

  function goToPreviousPage() {
    if (pageInViewportNumber >= 1) {
      const $prevPage = $('.page').eq(pageInViewportNumber - 2);
      util.bringInViewportMobile($prevPage);
    }
  }

  function goToNextPage() {
    if (pageInViewportNumber <= util.getNumberOfPages()) {
      const $nextPage = $('.page').eq(pageInViewportNumber);
      util.bringInViewportMobile($nextPage);
    }
  }

  return <header id="app-header" className="main slide-in-top mob">
    <div className="back-group" onClick={goToHomePage}>
      <a className="logo">
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-icon"}/>
        </svg>
      </a>
      <div className="timber-icon-ct">
        <svg className="timber-icon">
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-timber-icon"}/>
        </svg>
      </div>
    </div>

    <div className='mobile-history-btns'><History/></div>

    <div className="page-numbers-nav">
      <LeftOutlined style={{fontSize: '20px', color: pageInViewportNumber === 1 ? '#ccc' : '#333'}} onClick={() => goToPreviousPage()} />
      <div className="pages">
        <div>Page</div>
        <div className="page-number">{pageInViewportNumber} / {util.getNumberOfPages()}</div>
      </div>
      <RightOutlined style={{fontSize: '20px', color: pageInViewportNumber === util.getNumberOfPages() ? '#ccc' : '#333'}} onClick={() => goToNextPage()} />
    </div>

    {!isVersionPreview &&
    <button onClick={toggleMenu}>
      <svg>
        <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-nav-icon"}/>
      </svg>
    </button>}

    {isVersionPreview && <div className={'rev'}>
      <button onClick={discard}>Cancel</button>
      <button onClick={usePreview}>Use Version</button>
    </div>}
  </header>
}
